export default "__VITE_ASSET__CPUgdHsR__"